import axios from "axios";

export const askAi = (question, success, failure) => {
    const url = "/api/v1/help/ai";

    axios.post(url, {
        message: question,
    })
    .then(response => {
        const json = response.data;

        success(json.message);
    })
    .catch(err => {
        failure(err);
    });
};

export const askHuman = (question, success, failure) => {
    const url = "/api/v1/help/human";

    axios.post(url, {
        message: question,
    })
    .then(response => {
        success();
    })
    .catch(err => {
        failure(err);
    });
};
